<script>
import { onMount } from 'svelte';
import Main from './world3d/Main';

let canvasElement;
let main, btn, overlay;
let visible = false;

async function init() {
	main = new Main(canvasElement);
	btn = document.getElementById("btn-clicktoplay");
	overlay = document.getElementById("overlay");
	canvasElement.addEventListener("click", onClick);
}

function onClick(e) {
	console.log("click");
	main.onClick();
	visible = !visible
	if(visible) {
		overlay.classList.remove("visible");
	} else {
		// overlay.classList.add("visible");
	}
}

onMount(() => {
	canvasElement.width = window.innerWidth;
	canvasElement.height = window.innerHeight;

	init();
});

</script>

<main>
	<canvas width="100%" height="100%" bind:this={canvasElement}></canvas>
	<div id="overlay" class="visible">
		<div id="btn-clicktoplay">Click to play</div>
	</div>
</main>

<style>
canvas{
	width: 100%;
	height: 100%;
}

#overlay{
	background-color: rgba(0.0, 0.0, 0.0, 0.95);
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;

	display: none;
	pointer-events: none;
}

#btn-clicktoplay{
	font-family: 'Lausanne', sans-serif;
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	font-size: 30px;
	color: #07FF11;
	cursor: pointer;

	pointer-events: none;
}

.visible{
	display: block !important;
}
</style>